import { render, staticRenderFns } from "./SancionNew.vue?vue&type=template&id=b0e6cccc&scoped=true&"
import script from "./SancionNew.vue?vue&type=script&lang=ts&"
export * from "./SancionNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6cccc",
  null
  
)

export default component.exports